import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiDelete, apiPut } from '../lib/api.js';

export type CourseOverride = {
  masterCourseId: string;
  agencyNotes: string | null;
  commissionRateText: string | null;
  isPreferred: boolean;
  updatedAt: string;
};

export type UpsertOverridePayload = {
  agencyNotes: string | null;
  commissionRateText: string | null;
  isPreferred: boolean;
};

function invalidate(qc: ReturnType<typeof useQueryClient>, masterCourseId: string) {
  // The list query drives the Preferred badge; the detail query drives the editor + notes panel.
  void qc.invalidateQueries({ queryKey: ['courses'] });
  void qc.invalidateQueries({ queryKey: ['courses', 'detail', masterCourseId] });
}

export function useUpsertCourseOverride(masterCourseId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpsertOverridePayload) =>
      apiPut<{ override: CourseOverride }>(`/admin/overrides/${masterCourseId}`, payload),
    onSuccess: () => invalidate(qc, masterCourseId),
  });
}

export function useDeleteCourseOverride(masterCourseId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiDelete<void>(`/admin/overrides/${masterCourseId}`),
    onSuccess: () => invalidate(qc, masterCourseId),
  });
}
